// removed by extract-text-webpack-plugin
module.exports = {"DescriptionLists":"_19hWK4rERgxvfs0BdzorQ-","dl":"_35X4aam6GRCAeVcPGk232H","dlExpired":"_1BhGyaiRM4Qc9Fp4ZAE5VZ","eventTime":"_1fM2tSgLZQ1TbVJJ1Oi42R","eventTimeExpired":"_1K73vR8HbAVOEgKtSHC9rq"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DescriptionLists/DescriptionList.css
// module id = 288
// module chunks = 8